import {ValidationErrorItem} from "./validation-error-item.interface";

export interface ErrorsObjectInterface {
    [key: string]: ValidationErrorItem[] | ErrorsObjectInterface | (ErrorsObjectInterface | ValidationErrorItem[])[];
}
